import React from 'react';
import ConstructionCaseCard from '@/ui/ConstructionCaseCard';
import styled from 'styled-components';
import { theme } from '@/styles';
import { CustomScroll } from '@/styles/common';
import { getAsset } from '@/utils';
import Image from '@/ui/Image';
import BoardPagination from '@/ui/BoardPagination';
import useConstruction from '../hooks/useConstruction';

interface ConstructionPopupProps {
  tabState: string;
  shopId: number;
}

const ConstructionPopup = ({ tabState, shopId }: ConstructionPopupProps) => {
  const { constructList, page, setPage, isLoading, ref } = useConstruction({
    shopId,
    tabState,
  });
  return (
    <Container>
      {isLoading ? (
        <LoadingBox>
          <Image
            src={getAsset('/assets/icons/loading-obj-new.gif')}
            height={'40px'}
            width="40px"
            alt="loadingIcon"
          />
        </LoadingBox>
      ) : (
        <PopupWrap ref={ref}>
          {constructList?.content.map((item, index) => (
            <CardBox key={`construct_list_${item.id}`} width={'350px'}>
              <ConstructionCaseCard
                item={item}
                imgSize={{ width: '350px', height: '197px' }}
              />
            </CardBox>
          ))}
        </PopupWrap>
      )}
      <Footer>
        <BoardPagination
          // TEMP
          page={page}
          handlePage={setPage}
          totalPages={Number(constructList?.totalPages) || 1}
        />
      </Footer>
    </Container>
  );
};

export default ConstructionPopup;

const PopupWrap = styled.div`
  width: 100%;
  display: grid;
  min-height: 558px;
  height: 558px;
  overflow: auto;
  gap: 28px 20px;
  grid-template-columns: 1fr 1fr 1fr;
  padding-left: 40px;
  padding-right: 40px;
  ${CustomScroll};
`;

const CardBox = styled.div<{ width: string }>`
  width: ${({ width }) => width};
`;

const Footer = styled.div`
  display: flex;
  position: sticky;
  width: 100%;
  justify-content: center;
  height: 60px;
  bottom: 0px;
  background-color: ${theme.colors.neutral_colors.white};
  z-index: 999;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const LoadingBox = styled.div`
  width: 100%;
  height: 558px;
  display: flex;
  padding-top: 20%;
  justify-content: center;
  /* align-items: center; */
`;
